export enum OrderStatus {
	ALL = 0,
	NEW_ORDER = 1,
	PENDING_ORDER = 2,
	CONFIRMED_ORDER = 3,
	PENDING_SHIPPING_ORDER = 4,
	DELIVERY_IN_PROGRESS_ORDER = 5,
	DELIVERED_ORDER = 6,
	CANCELLED_ORDER = 7,
	//PENDING_REFUND_ORDER = 8,
	REFUNDED_ORDER = 9,
	PARTIALLY_REFUNDED_ORDER = 10,
}
export enum PaymentStatus {
	PAID = 1,
	UNPAID = 2,
}
export enum OrderPaymentMethodEnum {
	CASH = 1,
	PayOnline = 2,
	Wallet = 3,
}

export enum PaymentFilterOrderEnum {
	CASH = 1,
	PayOnline = 2,
	Wallet = 3,
}

export enum StatusDeliverOrderEnum {
	Delivered,
	cancelled,
}

export enum StatusHistoryOrderEnum {
	New_g,
	Shipped,
	Delivered,
}

export enum OrderTabsEnum {
	New,
	Shipped,
	History,
}

export const OrderTabs: {
	name: string
	value: boolean | string
	count: number
	showCount: boolean
}[] = []

Object.keys(OrderTabsEnum).forEach((value: string) =>
	isNaN(+value)
		? OrderTabs.push({
				name: value,
				value: OrderTabsEnum[value as any],
				count: 0,
				showCount: false,
		  })
		: null
)
